import React, { useState, useEffect } from 'react';
import Tooltip from './Tooltip';

import classnames from 'classnames';
import { format_date } from '../../helpers/dates'

const Performance = props => {

  const {data} = props;
  const doc = new DOMParser().parseFromString(data.html, 'text/html');
  const button = doc.querySelector('.button');
  const id = button.dataset.id;
  const hash = button.dataset.hash;
  const time = button.textContent;
  const href = button.href;

  const base_url = window.location.origin;
  const button_classes = button.classList;

  const [available, setAvailable] = useState(false);





  return (
    <div className="performance">
      <a href={href} data-hash={hash} data-id={id} className="button button-black">
      <span>{time}</span>
      {
        data.accessibility_class.length > 0 &&
          <span className={data.accessibility_class}></span>
      }
      </a>
      <Tooltip html={data.html} />
    </div>
  )
}

export default Performance;
